




import Vue from "vue";

export default Vue.extend({
  name: "CurrencyValue",
  props: {
    value: {
      type: Number,
      required: true,
    },
  },
});
